<template>
    <div>
        <select-task
                     v-if="showTasks"
                     :tasks="options"
                     :button_text="`Set Task (${selectedItems.length} records)`"
                     class="mb-2 border-bottom"
                     @button-click="handleUpdateTaskClick" />

        <DataListPagination v-if="messages"
                            :dataCols="dataListCols"
                            :dataListItems="messages"
                            :showCheckbox="showTasks"
                            :tableClass="'table table-striped table-sm'"
                            :totalRecords="pagination ? pagination.totalRecords : null"
                            :pageNumber="pagination ? pagination.pageNumber : null"
                            :pageSize="pagination ? pagination.pageSize : null"
                            :iconFuncs="[messageIcon,messageIconTask,messageIconAttachment]"
                            :actions="getActions"
                            @action-click="handleActionClick"
                            @change="handleSelectedItemsChange"
                            @dbl-click="messageDoubleClick"
                            @pagination-input="messagePaginationClickEvent"
                            @column-click="handleSortClick" />
        <slideout-panel v-if="selectedMessage" :key="'slideout-panel_assign_' + selectedMessage.id"></slideout-panel>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import {
        GET_EMAIL_DOCUMENT,
        GET_EMAIL_DOCUMENT_COMPLETE,
        MESSAGES_PAGINATION,
        MESSAGES_COLUMN_CLICK,
        GET_TAGS_FOR_CLAIM_MESSAGE,
        GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE,
        MESSAGE_VIEWER_CLOSED,
        SET_MESSAGE_TASK,
        SET_MESSAGE_DELETED
    } from '@/messageEvents.js';

    import DataListPagination from "@/components/DataListPagination.vue";
    import SelectTask from '@/components/SelectTask.vue'

    export default {
        name: "messages-list",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            dataListCols: {
                type: Array,
                required: true
            },
            messages: {
                type: Array,
                required: true
            },
            pagination: {
                type: Object,
                required: false,
                default: () => { }
            },
            windowWidth: {
                required: true
            },
            buttonConfig: {
                type: Object,
                required: false
            },
            showTasks: {
                type: Boolean,
                required: false,
                default: true
            },
            showActions: {
                type: Boolean,
                required: false,
                default: false
            }
            //availableTags: {
            //    type: Array,
            //    required: false,
            //    default: () => []
            //}
        },
        components: {
            DataListPagination,
            SelectTask
        },
        data: () => {
            return {
                selectedMessage: null,
                availableTags: [],
                selectedItems: [],
                options: [
                    { text: 'Completed', value: '1014' }
                ],
            };
        },
        computed: {
            canUserDeleteMessage() {
                return this.$adminUser.isClaimManager() || this.$adminUser.isClaimTeamLeader();
            },
            deleteActionDisabled() { return !this.canUserDeleteMessage},
            getActions() {
                if (this.showActions) {
                    return [{ text: 'Delete', disabled: () => this.deleteActionDisabled }]
                } else {
                    return null
                }
                
            }
        },
        methods: {
            messagePaginationClickEvent(pageNumber) {
                EventBus.$emit(MESSAGES_PAGINATION + '_' + this.eventTarget, pageNumber);
            },
            messageDoubleClick(message) {
                this.selectedMessage = message
                EventBus.$emit(GET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget, message);

                EventBus.$once(GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + message.id, (payload) => {
                    //console.log(GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + message.id + ': ', payload)
                    this.availableTags = payload
                });

                EventBus.$emit(GET_EMAIL_DOCUMENT + '_' + this.eventTarget, message);

                EventBus.$once(GET_EMAIL_DOCUMENT_COMPLETE + '_' + message.id, (payload) => {
                    //console.log(GET_EMAIL_DOCUMENT_COMPLETE + '_' + message.id + ': ', payload)
                    const panel1Handle = this.$showPanel({
                        component: "message-viewer",
                        openOn: "right",
                        cssClass: "",
                        width: this.windowWidth * 0.99,
                        props: {
                            eventTarget: this.eventTarget,
                            buttonConfig: this.buttonConfig,
                            messageHeader: this.selectedMessage,
                            messageDocument: payload,
                            windowWidth: this.windowWidth,
                            availableTags: this.availableTags
                        }
                    });

                    panel1Handle.promise.then(() => { EventBus.$emit(MESSAGE_VIEWER_CLOSED) });
                });
            },
            handleSortClick(payload) {
                //console.log(payload)
                EventBus.$emit(MESSAGES_COLUMN_CLICK + '_' + this.eventTarget, payload);
            },
            messageIcon(item) {
                if (item && item.read == true) {
                    return 'far fa-envelope-open'
                } else {
                    return 'far fa-envelope'
                }
            },
            messageIconTask(item) {
                if (item && item.taskCompleted == true) {
                    return 'fas fa-check'
                } else {
                    return 'fas fa-minus'
                }
            },
            messageIconAttachment(item) {
                if (item && item.attachments && item.attachments.length > 0) {
                    return 'fas fa-paperclip'
                } else {
                    return ''
                }
            },
            handleSelectedItemsChange(payload) {
                this.selectedItems = payload
            },
            handleUpdateTaskClick(payload) {
                //console.log('handleUpdateTaskClick')
                //console.log('handleUpdateTaskClick: ', payload)
                if (this.selectedItems && this.selectedItems.length > 0) {
                    //console.log('Selected: ', this.selectedItems)
                    EventBus.$emit(SET_MESSAGE_TASK + '_' + this.eventTarget, { taskId: payload[0], items: this.selectedItems });
                }
            },
            handleActionClick(payload) {
                console.log(payload)
                if (payload.action.text == 'Delete') {
                    this.$bvModal.msgBoxConfirm('Please confirm that you wish to delete the selected message!')
                        .then(value => {
                            if (value == true) {
                                EventBus.$emit(SET_MESSAGE_DELETED + '_' + this.eventTarget, payload.item)
                            }
                        })
                        .catch(err => {
                            // An error occurred
                        })
                }
            }
        },
        mounted() {
           
        }
    };
</script>

